import { render, staticRenderFns } from "./KeybeButton.vue?vue&type=template&id=2fdd2455&scoped=true&"
import script from "./KeybeButton.vue?vue&type=script&lang=ts&"
export * from "./KeybeButton.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeButton.vue?vue&type=style&index=0&id=2fdd2455&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd2455",
  null
  
)

export default component.exports